import { Component, OnInit } from '@angular/core';
import { URLS } from '../../constants/URLS';
import { CategoryService } from '../../_service/category.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.css']
})
export class ChannelComponent implements OnInit {

  channelData:any;
  flixsChannels:any[] = [];
  vidsChannels:any[] = [];
  isLoading:boolean=false;
  channelUrl: String = environment.TQR_SERVICE + 'cms/cms-channels/';
  mediaUrl: string = URLS.BASE_URL + '/static/post_videos/';
  selectedTab: string = 'All Channels';
  selectedCategory:string = 'Flixs';
  userSubscriptions:any[] = [];
  transactions:any[] = [];

  constructor( 
    private categ: CategoryService, 
    private walletService: WalletinfoService,
    private route: ActivatedRoute,
    private router: Router
    ) { 
      this.route.queryParams.subscribe((params)=>{
        if(params['tab']){
          this.selectedTab = params['tab'];
        }
      })
    }

  ngOnInit() {
    this.getChannelsData();
    this.getUserSubscriptions();
    this.getUserTransactions();
  }

  getChannelsData(){
    this.isLoading = true;
    this.categ.getChannelInfoByUserId().subscribe((result)=>{
      this.channelData = result;
      this.channelData.map((channel)=>{
        if(channel.channelCategory === 'PRIME'){
          
          this.flixsChannels.push(channel);
        }else if(channel.channelCategory === 'CC_PRIME'){
          this.vidsChannels.push(channel);
        }
      })
      console.log(this.channelData)
      this.mapSubscription();
      console.log(this.flixsChannels);
      this.isLoading = false;
    },(error)=>{
      this.isLoading = false;
      if(error?.statusText === 'Unknown Error'){
        this.channelData = JSON.parse(localStorage.getItem('channelData'));
        this.channelData?.map((channel)=>{
          if(channel.channelCategory === 'PRIME'){
            this.flixsChannels.push(channel);
          }else if(channel.channelCategory === 'CC_PRIME'){
            this.vidsChannels.push(channel);
          }
        })
      }
    });
  }

  mapSubscription() {
    this.flixsChannels.forEach(section => {
      section.expiringDate = '';
      this.userSubscriptions.forEach(sitem => {
        if(section.channelId == sitem.channelId && sitem.isActive){
          section.isChannelSubscribed = true;
          section.expiringDate = sitem.dateOfExpiry;
        }
      })
    })
  }

  getUserSubscriptions(){
    this.walletService.getUserSubscriptions().subscribe((result) => {
      console.log(result);
    
      this.userSubscriptions = result.filter((item)=>{
        if(item?.isActive){
          console.log(item)
          return item
        }
      });
      // this.userSubscriptions = result.filter((subscription:any) => {
      //   const expiryDate = new Date(subscription.dateOfExpiry);
      //   return expiryDate > new Date();
      // });
    
      // this.userSubscriptions.forEach(subscription => {
      //   console.log(subscription);
      // });
    });
  }

  getUserTransactions(){
    this.walletService.getUserTransaction().subscribe((result) => {
      console.log(result);
      result.map((transaction)=>{
        if(transaction.eventType === "SUBSCRIPTION_FROM_WALLET" || transaction.eventType === "SUBSCRIPTION_FROM_CASHFREE"){
          this.transactions.push(transaction);
        }
      })
      console.log(this.transactions)
    });
  }

  showPlansModal(event:Event, channel:any){
    this.router.navigate(['/channelplans'], {
      queryParams:{
        channelId: channel?.channelId,
        channelName: channel?.name,
        vidLibId: channel?.vidLibId
      }
    })
  }

  // showPlansModal(event:Event, channel:any){
  //   event.stopImmediatePropagation();
  //   const dialogRef = this.dialog.open(SubscriptionModalComponent, {
  //     panelClass: 'subscription-dialog',
  //     data: {
  //       channelId: channel?.channelId,
  //       channelName: channel?.name,
  //       vidLibId: channel?.vidLibId
  //     },
  //   });    

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //   });
  // }
}
